import { gsap } from 'gsap';

export default () => {

	const arrowCursors = document.querySelectorAll('.js-arrow-cursor');
	if (!arrowCursors.length) return;

	arrowCursors.forEach(cursor => {

		const parent = cursor.parentElement;

		let cursorLeftPosition = parent.clientWidth / 2;
		let cursorTopPosition = parent.clientHeight / 2;

		parent.addEventListener('mousemove', e => {
			cursor.classList.remove('is-invisible');

			const parentCoords = parent.getBoundingClientRect();
			cursorLeftPosition = e.clientX - parentCoords.left;
			cursorTopPosition = e.clientY - parentCoords.top;

			gsap.set(cursor, {
				x: cursorLeftPosition,
				y: cursorTopPosition
			});
		});

		parent.addEventListener('mouseleave', () => {
			cursor.classList.add('is-invisible');
		});

	})

}
